/**
 * Catalogusfilters voor Materiaalbeheer (26 sep 2026): status, materiaaltype en
 * opslaglocatie naast de bestaande categorie-chips. Een materiaal (type-kaart) blijft
 * zichtbaar als minstens één exemplaar aan álle gekozen exemplaar-filters voldoet.
 */

// Opslaglocatie-keuzes in Airtable (Materialen → Opslaglocatie, fld2l8t8RMMEDvuZd).
export const LOCATIES = ['Amsterdam', 'Tilburg'];

export const STATUS_FILTERS = [
  { key: 'beschikbaar', label: 'Beschikbaar' },
  { key: 'reparatie', label: 'Op reparatie' },
  { key: 'afwezig', label: 'Lange tijd afwezig' },
  { key: 'marktplaats', label: 'Marktplaats' },
  { key: 'verkocht', label: 'Verkocht/gearchiveerd' },
];

/** Zelfde regel als de engine (services/materiaal_reparatie.is_op_reparatie). */
export function statusGroep(status, reparatiestatus) {
  const s = String(status || '').trim();
  if (s.startsWith('Reparatie')) return 'reparatie';
  if (s === 'Verkocht/gearchiveerd') return 'verkocht';
  if (s === 'Marktplaats') return 'marktplaats';
  if (String(reparatiestatus || '').trim()) return 'reparatie';
  if (s === 'Lange tijd afwezig') return 'afwezig';
  return 'beschikbaar'; // leeg of legacy 'In gebruik'
}

function locatieVan(mat) {
  const raw = mat?.fields?.Opslaglocatie;
  return Array.isArray(raw) ? (raw[0] || '') : String(raw || '');
}

export function exemplaarPast(mat, { status, locatie } = {}) {
  const f = mat?.fields || {};
  if (status && statusGroep(f.Status, f.Reparatiestatus) !== status) return false;
  if (locatie) {
    const l = locatieVan(mat);
    if (locatie === '__geen__' ? !!l : l !== locatie) return false;
  }
  return true;
}

export function filterGroepen(groepen, { status = '', typeId = null, locatie = '' } = {}) {
  let lijst = groepen || [];
  if (typeId) lijst = lijst.filter((g) => g.type?.id === typeId);
  if (status || locatie) lijst = lijst.filter((g) => (g.children || []).some((c) => exemplaarPast(c, { status, locatie })));
  return lijst;
}
